export default __webpack_public_path__ + "static/demolition-cost-9d66da8d7e6b19e005d50ea7225dc4c4.png";